import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SupportWorldsBlockData from '../../../Models/Content/SupportWorldsBlockData';
import SupportWorlds from './SupportWorldsBlock';

export default class SupportWorldsBlock extends EpiComponent<SupportWorldsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = [''];

    return (
      <div className={cssClasses.join(" ")}>
            <SupportWorlds iContent={this.props.data} context={this.getContext()} componentProps={this.props.componentProps} />
      </div>

    )
  }
}
